import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { BreadCrumb } from "../breadcrumb/breadcrumb.component";
import { IdsForSettingsService } from "./ids-for-settings.service";


export class BreadCrumbOptions {

  public static Dashboard: BreadCrumb = new BreadCrumb("Dashboard", "/dashboard");
  public static Settings: BreadCrumb = new BreadCrumb("Settings", "/settings");

  public static Account: BreadCrumb = new BreadCrumb("Account", "/settings/account");
  public static Account_Profile: BreadCrumb = new BreadCrumb("Profile", "/settings/account/profile");
  public static Account_Signature: BreadCrumb = new BreadCrumb("Signature", "/settings/account/signature");
  public static Account_Security: BreadCrumb = new BreadCrumb("Security", "/settings/account/security");
  public static Account_Roles: BreadCrumb = new BreadCrumb("Roles", "/settings/account/roles");
  public static Account_Workgroups: BreadCrumb = new BreadCrumb("Workgroups", "/settings/account/workgroups");

  public static Application(organisationGuid: string): BreadCrumb { return new BreadCrumb("Application", "/settings/application/" + organisationGuid); }
  public static Application_Request(organisationGuid: string): BreadCrumb { return new BreadCrumb("Requests", "/settings/application/" + organisationGuid + "/requests"); }
  public static Application_Signing(organisationGuid: string): BreadCrumb { return new BreadCrumb("Signing", "/settings/application/" + organisationGuid + "/signing"); }
  public static Application_Documents(organisationGuid: string): BreadCrumb { return new BreadCrumb("Documents", "/settings/application/" + organisationGuid + "/documents"); }
  public static Application_Email(organisationGuid: string): BreadCrumb { return new BreadCrumb("Email", "/settings/application/" + organisationGuid + "/email"); }

  public static Security(organisationGuid: string): BreadCrumb { return new BreadCrumb("Security", "/settings/security/" + organisationGuid); }
  public static Security_General(organisationGuid: string): BreadCrumb { return new BreadCrumb("General", "/settings/security/" + organisationGuid + "/general"); }
  public static Security_Identity(organisationGuid: string): BreadCrumb { return new BreadCrumb("Identity", "/settings/security/" + organisationGuid + "/identity"); }
  public static Security_Validation(organisationGuid: string): BreadCrumb { return new BreadCrumb("Validation", "/settings/security/" + organisationGuid + "/validation"); }
  public static Security_Sso(organisationGuid: string): BreadCrumb { return new BreadCrumb("Sso", "/settings/security/" + organisationGuid + "/sso"); }

  public static Integrations(organisationGuid: string): BreadCrumb { return new BreadCrumb("Security", "/settings/integrations/" + organisationGuid); }
  public static Integrations_Platform(organisationGuid: string): BreadCrumb { return new BreadCrumb("Platform", "/settings/integrations/" + organisationGuid + "/platformApi"); }
  public static Integrations_Documents(organisationGuid: string): BreadCrumb { return new BreadCrumb("Documents", "/settings/integrations/" + organisationGuid + "/documents"); }
  public static Integrations_Addressbook(organisationGuid: string): BreadCrumb { return new BreadCrumb("Addressbook", "/settings/integrations/" + organisationGuid + "/addressbook"); }
  public static Integrations_Services(organisationGuid: string): BreadCrumb { return new BreadCrumb("Services", "/settings/integrations/" + organisationGuid + "/services"); }

  public static Organisation(organisationGuid: string): BreadCrumb { return new BreadCrumb("Organisation", "/settings/organisation/" + organisationGuid); }
  public static Organisation_Overview(organisationGuid: string): BreadCrumb { return new BreadCrumb("Overview", "/settings/organisation/" + organisationGuid + "/overview"); }
  public static Organisation_Users(organisationGuid: string): BreadCrumb { return new BreadCrumb("Users", "/settings/organisation/" + organisationGuid + "/users"); }
  public static Organisation_User_Selected(organisationGuid: string, userId: string): BreadCrumb { return new BreadCrumb("Users", "/settings/organisation/" + organisationGuid + "/users/" + userId + "/profile"); }
  public static Organisation_Workgroups(organisationGuid: string): BreadCrumb { return new BreadCrumb("Workgroups", "/settings/organisation/" + organisationGuid + "/workgroups"); }
  public static Organisation_Credits(organisationGuid: string): BreadCrumb { return new BreadCrumb("Credits", "/settings/organisation/" + organisationGuid + "/credits"); }
  public static Organisation_Storage(organisationGuid: string): BreadCrumb { return new BreadCrumb("Storage", "/settings/organisation/" + organisationGuid + "/storage"); }
  public static Organisation_Branding(organisationGuid: string): BreadCrumb { return new BreadCrumb("Branding", "/settings/organisation/" + organisationGuid + "/branding"); }
  public static Organisation_Permissions(organisationGuid: string): BreadCrumb { return new BreadCrumb("Permissions", "/settings/organisation/" + organisationGuid + "/permissions"); }
  public static Organisation_Selected(organisationGuid: string): BreadCrumb { return new BreadCrumb("", "/settings/organisation/" + organisationGuid + "/overview"); }
  // these are ALWAYS final so need no navigation :P
  public static Organisation_User_Selected_Profile = new BreadCrumb("Profile", "");
  public static Organisation_User_Selected_Signature = new BreadCrumb("Signature", "");
  public static Organisation_User_Selected_Security = new BreadCrumb("Security", "");
  public static Organisation_User_Selected_Roles = new BreadCrumb("Roles", "");
  public static Organisation_User_Selected_Workgroups = new BreadCrumb("Workgroups", "");


  public static Whitelabel(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Whitelabel", "/settings/whitelabel/" + whitelabelGuid); }
  public static Whitelabel_Overview(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Overview", "/settings/whitelabel/" + whitelabelGuid + "/overview"); }
  public static Whitelabel_Organisations(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Organisations", "/settings/whitelabel/" + whitelabelGuid + "/organisations"); }
  public static Whitelabel_Workgroups(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Workgroups", "/settings/whitelabel/" + whitelabelGuid + "/workgroups"); }
  public static Whitelabel_Credits(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Credits", "/settings/whitelabel/" + whitelabelGuid + "/credits"); }
  public static Whitelabel_Storage(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Storage", "/settings/whitelabel/" + whitelabelGuid + "/storage"); }
  public static Whitelabel_Branding(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Branding", "/settings/whitelabel/" + whitelabelGuid + "/branding"); }
  public static Whitelabel_Permissions(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("Permissions", "/settings/whitelabel/" + whitelabelGuid + "/permissions"); }
  public static Whitelabel_Selected(whitelabelGuid: string): BreadCrumb { return new BreadCrumb("", "/settings/whitelabel/" + whitelabelGuid + "/overview"); }


  public static System: BreadCrumb = new BreadCrumb("System", "/settings/system/overview");
  public static System_Overview: BreadCrumb = new BreadCrumb("Overview", "/settings/system/overview");
  public static System_WhiteLabelProviders: BreadCrumb = new BreadCrumb("WhiteLabelProviders", "/settings/system/whitelabelproviders");
  public static System_Storage: BreadCrumb = new BreadCrumb("Storage", "/settings/system/storage");
  public static System_Branding: BreadCrumb = new BreadCrumb("Branding", "/settings/system/branding");
  public static System_Permissions: BreadCrumb = new BreadCrumb("Permissions", "/settings/system/permissions");

}


@Injectable({
  providedIn: 'root'
})
export class SettingsBreadCrumbService implements OnDestroy {


  private dashboardBreadCrumb: BreadCrumb = BreadCrumbOptions.Dashboard;
  private settingsBreadCrumb: BreadCrumb = BreadCrumbOptions.Settings;

  private settingsBreadCrumbs: BreadCrumb[] = [this.dashboardBreadCrumb, this.settingsBreadCrumb];

  public settingBreadCrumbs$: BehaviorSubject<BreadCrumb[]> = new BehaviorSubject(this.settingsBreadCrumbs);

  private MainSection_BreadCrumb: BreadCrumb | null = null; //  1 of 7 mains: account/application
  private OrganisationName_BreadCrumb: BreadCrumb | null = null; // organisationName -> subsection
  private WhitelabelName_BreadCrumb: BreadCrumb | null = null; // WhitelabelName -> subsection
  private SubSection_BreadCrumb: BreadCrumb | null = null; //  ^
  private UserName_BreadCrumb: BreadCrumb | null = null;  // username 
  private FinalSection_BreadCrumb: BreadCrumb | null = null;  // ^ profile etc

  private orgSubscription!: Subscription;
  private organisationIdForUrl: string = "";
  private userSubscription!: Subscription;
  private whitelabelSubscription!: Subscription;
  private whitelabelIdForUrl: string = "";


  private shouldDisplayUser = false;
  private shouldDisplayOrganisation = false;
  private shouldDisplayWhitelabel = false;
  private shouldDisplaySystem = false;
  // dashboard
  // settings
  // main section for settings
  // subsection for settings   ||   organisation name
  // null or sub section for organisation
  // null or username


  public SetCrumbs(main: BreadCrumb, Sub: BreadCrumb | null = null) {
    this.MainSection_BreadCrumb = main;
    this.SubSection_BreadCrumb = Sub;
    this.shouldDisplayOrganisation = false;
    this.shouldDisplayUser = false;
    this.shouldDisplayWhitelabel = false;
    this.pushBreadCrumbs();
  }

  public SetOrganisationBasedCrumbs(main: BreadCrumb, Sub: BreadCrumb | null = null) {
    this.MainSection_BreadCrumb = main;
    this.SubSection_BreadCrumb = Sub;
    this.shouldDisplayUser = false;
    this.shouldDisplayOrganisation = true;
    this.shouldDisplayWhitelabel = false;
    this.shouldDisplaySystem = false;
    //this.shouldDisplayUser doesnt have to be changed here, this is changed by the organisationUser
    this.pushBreadCrumbs();
  }
  public SetOrganisationCrumbs(Sub: BreadCrumb) {
    this.MainSection_BreadCrumb = BreadCrumbOptions.Organisation(this.organisationIdForUrl);
    this.SubSection_BreadCrumb = Sub;
    this.shouldDisplayUser = false;
    this.shouldDisplayOrganisation = true;
    this.shouldDisplayWhitelabel = false;
    this.shouldDisplaySystem = false;
    //this.shouldDisplayUser doesnt have to be changed here, this is changed by the organisationUser
    this.pushBreadCrumbs();
  }
  public SetOrganisationUserCrumbs(subSectionUsers: BreadCrumb, userGuid: string) {
    this.MainSection_BreadCrumb = BreadCrumbOptions.Organisation(this.organisationIdForUrl);
    this.SubSection_BreadCrumb = BreadCrumbOptions.Organisation_User_Selected(this.organisationIdForUrl, userGuid);
    this.FinalSection_BreadCrumb = subSectionUsers;
    this.shouldDisplayUser = true;
    this.shouldDisplayOrganisation = true;
    this.shouldDisplayWhitelabel = false;
    this.shouldDisplaySystem = false;
    this.pushBreadCrumbs();
  }
  public SetWhiteLabelCrumbs(Sub: BreadCrumb) {
    this.MainSection_BreadCrumb = BreadCrumbOptions.Whitelabel(this.organisationIdForUrl);
    this.SubSection_BreadCrumb = Sub;
    this.shouldDisplayUser = false;
    this.shouldDisplayOrganisation = false;
    this.shouldDisplayWhitelabel = true;
    this.shouldDisplaySystem = false;
    this.pushBreadCrumbs();
  }
  public SetSystemCrumbs(Sub: BreadCrumb) {
    this.MainSection_BreadCrumb = BreadCrumbOptions.System;
    this.SubSection_BreadCrumb = Sub;
    this.shouldDisplayUser = false;
    this.shouldDisplayOrganisation = false;
    this.shouldDisplayWhitelabel = false;
    this.shouldDisplaySystem = true;
    this.pushBreadCrumbs();
  }

  constructor(private idsForSettingsService: IdsForSettingsService) {

    // subscribe so we can update the breadcrumb/url
    this.orgSubscription = this.idsForSettingsService.selectedOrganisation$.subscribe(organisation => {
      if (!organisation || organisation.organisationName == "") {
        this.OrganisationName_BreadCrumb = null;
        this.organisationIdForUrl = "";
      } else {
        this.organisationIdForUrl = organisation.organisationGuid;
        this.OrganisationName_BreadCrumb = BreadCrumbOptions.Organisation_Selected(organisation.organisationGuid);
        this.OrganisationName_BreadCrumb.displayTitle = organisation.organisationName;
      }
      this.pushBreadCrumbs();
    });
    // subscribe so we can update the breadcrumb/url
    this.whitelabelSubscription = this.idsForSettingsService.selectedWhiteLabel$.subscribe(whitelabel => {
      if (!whitelabel || whitelabel.whiteLabelName == "") {
        this.WhitelabelName_BreadCrumb = null;
        this.whitelabelIdForUrl = "";
      } else {
        this.whitelabelIdForUrl = whitelabel.whiteLabelGuid;
        this.WhitelabelName_BreadCrumb = BreadCrumbOptions.Organisation_Selected(whitelabel.whiteLabelGuid);
        this.WhitelabelName_BreadCrumb.displayTitle = whitelabel.whiteLabelName;
      }
      this.pushBreadCrumbs();
    });

    // subscribe so we can update the breadcrumb/url
    this.userSubscription = this.idsForSettingsService.selectedUser$.subscribe(userInfo => {
      if (userInfo.fullName == "") {
        this.UserName_BreadCrumb = null;
      } else {
        this.UserName_BreadCrumb = BreadCrumbOptions.Organisation_User_Selected(this.organisationIdForUrl, userInfo.userGuid);
        this.UserName_BreadCrumb.displayTitle = userInfo.fullName;
      }
      this.pushBreadCrumbs();
    });
  }
  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
    this.orgSubscription.unsubscribe();
    this.whitelabelSubscription.unsubscribe();
  }

  private pushBreadCrumbs() {
    this.settingsBreadCrumbs = [
      this.dashboardBreadCrumb,
      this.settingsBreadCrumb
    ];
    if (this.MainSection_BreadCrumb != null) {
      this.settingsBreadCrumbs.push(this.MainSection_BreadCrumb);
    }
    if (this.OrganisationName_BreadCrumb != null && this.shouldDisplayOrganisation) {
      this.settingsBreadCrumbs.push(this.OrganisationName_BreadCrumb);
    }
    if (this.WhitelabelName_BreadCrumb != null && this.shouldDisplayWhitelabel) {
      this.settingsBreadCrumbs.push(this.WhitelabelName_BreadCrumb);
    }
    if (this.SubSection_BreadCrumb != null) {
      this.settingsBreadCrumbs.push(this.SubSection_BreadCrumb);
    }
    if (this.UserName_BreadCrumb != null && this.shouldDisplayUser) {
      this.settingsBreadCrumbs.push(this.UserName_BreadCrumb);
    }
    if (this.FinalSection_BreadCrumb && this.shouldDisplayUser) {
      this.settingsBreadCrumbs.push(this.FinalSection_BreadCrumb);
    }

    this.settingBreadCrumbs$.next(this.settingsBreadCrumbs);
  }

}
